import React, { useEffect, useRef, useState } from 'react';
import DOMPurify from 'dompurify';
import { useSelector, useStore } from 'react-redux';
import { useLocation } from 'react-router-dom';
import LocalizedLink from 'helpers/LocalizeLink';
import { setMobile } from "state/actions";
import HeaderBoxWidget from 'components/widgets/HeaderBoxWidget'
import HeaderHomeBoxWidget from 'components/widgets/HeaderHomeBoxWidget'
import logo from 'assets/img/logo.svg';
import { Helmet } from 'react-helmet';
import Widgets from 'components/widgets';
import HeaderAccountMenu from './HeaderAccountMenu';
import { Modal } from 'antd';

const Logo = () => {
    return (
        <div className="logo col-4 col-sm-3 col-md-2">
            <LocalizedLink to={'/'}>
                <img alt={'logo'} src={logo} className='w-100' />
            </LocalizedLink>
        </div>
    )
}

function Header() {
    const headerContent = useSelector(store => store.headerContent);
    const location = useLocation();
    const { dispatch } = useStore();
    const headerWidth = useRef(null);
    const isHomePage = (location.pathname === "" || location.pathname === "/");
    const [scrolled] = React.useState(false);
    const [scrolling] = React.useState(false);
    const [opacity] = React.useState(1);
    const [headerWidget, setHeaderWidget] = useState(null);

    const handleAlert = (event) => {
        Modal.info({
            closable: true,
            title: event?.data?.title,
            content: <p className="text-medium" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(event?.data?.content || '') }}></p>
        })
    }

    const handleScrollHome = () => {
        const header = document.getElementsByTagName("header")[0];
        const el = document.getElementsByClassName("header__bottom")[0];
        const bg = document.getElementsByClassName("header-top-bg")[0];
        const bg_rect = bg.getBoundingClientRect();
        const header_rect = header.getBoundingClientRect();
        const offsetOpacity = 0.15;

        if ((header_rect.height - bg_rect.height + header_rect.top) > 0) {
            let el_opacity = (header_rect.height - bg_rect.height + header_rect.top) / (header_rect.height - bg_rect.height)
            if (el_opacity < 0) {
                el_opacity = 0
            } else if (el_opacity > (1 - offsetOpacity)) {
                el_opacity = 1 - offsetOpacity
            }
            bg.style.opacity = 0
            el.style.opacity = el_opacity
        } else {
            bg.style.opacity = 1 - offsetOpacity
            el.style.opacity = 0
        }
    }

    const HeaderBottomContent = (props) => {
        if (headerContent?.widget === 'header_box') {
            return (<HeaderBoxWidget
                {...headerContent}
            />)
        }

        if (headerContent?.widget === 'header_home_box') {
            return (<HeaderHomeBoxWidget
                {...headerContent}
            />)
        }

        return headerWidget
    }

    const handleCheckHeaderWidth = () => {
        if (headerWidth.current.getBoundingClientRect().width < 768) {
            dispatch(setMobile(true));
        } else {
            dispatch(setMobile(false));
        }
    }

    let x = []
    if (scrolled) {
        x.push('scrolled')
        x.push('header_fixed')
    } else {
        x = []
    }

    useEffect(() => {
        handleCheckHeaderWidth();
    }, [])

    useEffect(() => {
        window.addEventListener('alertEvent', handleAlert)
        return () => {
            window.removeEventListener('alertEvent', handleAlert)
        }
    })

    useEffect(() => {
        window.addEventListener('scroll', handleScrollHome)
        return () => {
            window.removeEventListener('scroll', handleScrollHome)
        }
    })

    useEffect(() => {
        window.addEventListener('resize', handleCheckHeaderWidth)
        return () => {
            window.removeEventListener('resize', handleCheckHeaderWidth)
        }
    })

    useEffect(() => {
        if (headerContent?.widget) {
            if (headerContent.widget === 'header_box') { }
            else {
                setHeaderWidget(
                    React.createElement(Widgets[headerContent.widget], {
                        ...headerContent,
                        className: ''
                    }))
            }
        } else {
            setHeaderWidget(null)
        }
    }, [headerContent.widget])

    return (
        <>
            <Helmet>
                <title>{headerContent?.title}</title>
                {
                    headerContent.descriptions ?
                        <meta name="description" content={headerContent.descriptions} /> : null
                }
                {
                    headerContent.description ?
                        <meta name="description" content={headerContent.description} /> : null
                }
            </Helmet>
            <header ref={headerWidth} className={'header' + (isHomePage || (headerContent && headerContent?.widget === ' header_home_box') ? ' big_header ' : '') + x.join(' ')}>
                <div className='container-xl'>
                    <div className="header-top-bg d-block w-100"></div>

                    <div className={'header__top row d-flex justify-content-between align-items-center py-28 py-sm-16' + x.join(' ') + (scrolling ? " scrolling" : "")}>
                        <Logo />
                        <HeaderAccountMenu />
                    </div>
                    <div data-test-id="header-wr" className={'header__bottom row pt-124 pt-sm-92' + (headerContent?.title && headerContent?.descriptions ? " pb-28 pb-sm-12" : " pb-0")} style={{ opacity: opacity }}>
                        <HeaderBottomContent />
                    </div>

                </div>
            </header>
        </>
    )
}

export default Header;